var __jsx = React.createElement;
import React from "react";
import { useCMS } from "@hooks/useCMS";
import { twMerge } from "tailwind-merge";
var BenefitsComparison = function BenefitsComparison(_ref) {
  var _data$table_head;
  var data = _ref.data;
  var _useCMS = useCMS(),
    imageUrl = _useCMS.imageUrl;
  // Use API data if available
  var title = data === null || data === void 0 ? void 0 : data.title;
  var subtitle = data === null || data === void 0 ? void 0 : data.subtitle;
  var tableHeaders = ((data === null || data === void 0 ? void 0 : (_data$table_head = data.table_head) === null || _data$table_head === void 0 ? void 0 : _data$table_head.table_row) || []).filter(function (header) {
    return (header === null || header === void 0 ? void 0 : header.text) || (header === null || header === void 0 ? void 0 : header.image);
  });
  var tableRows = (data === null || data === void 0 ? void 0 : data.table_contents) || [];
  return /*#__PURE__*/React.createElement("section", {
    id: "benefits-comparison-section",
    className: "my-6 md:my-12 px-4 md:px-5 py-10 md:py-16"
  }, /*#__PURE__*/React.createElement("div", {
    id: "benefits-comparison-container",
    className: "max-w-[1200px] mx-auto"
  }, /*#__PURE__*/React.createElement("h2", {
    id: "benefits-comparison-title",
    className: "text-primary-new text-[20px] font-bold leading-[32px] md:text-[32px] text-center  mb-3 md:mb-4"
  }, data.title), /*#__PURE__*/React.createElement("p", {
    id: "benefits-comparison-subtitle",
    className: "text-base md:text-[20px] font-medium text-gray-600 text-center mb-8 md:mb-12 px-4"
  }, subtitle), /*#__PURE__*/React.createElement("div", {
    id: "benefits-comparison-table-wrapper",
    className: "max-w-full mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    id: "benefits-comparison-table",
    className: "bg-white rounded-xl shadow-[0_2px_10px_rgba(0,0,0,0.1)] overflow-hidden"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "benefits-comparison-table-header",
    className: "grid grid-cols-[minmax(140px,1fr)_90px_110px] md:grid-cols-3 gap-0"
  }, /*#__PURE__*/React.createElement("div", {
    id: "benefits-comparison-table-header-empty",
    className: "p-3 md:p-6 flex items-center justify-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-xs md:text-base font-bold  leading-tight"
  }))), tableHeaders.map(function (header, index) {
    return /*#__PURE__*/React.createElement("div", {
      id: "benefits-comparison-table-header-".concat(index),
      key: index,
      className: "flex items-center justify-center ".concat(index === 0 ? "bg-[#E7E7F8] " : index === 1 ? "" : "bg-white")
    }, !(header !== null && header !== void 0 && header.image) ? /*#__PURE__*/React.createElement("div", {
      className: "text-center"
    }, /*#__PURE__*/React.createElement("div", {
      id: "benefits-comparison-header-text-".concat(index),
      className: "text-xs md:text-base font-bold leading-tight"
    }, header.text)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      id: "benefits-comparison-header-image-container-".concat(index),
      className: "flex-1 p-4  flex items-center justify-center  max-w-[68px] md:max-w-[108px] md:w-[108px]"
    }, /*#__PURE__*/React.createElement("img", {
      id: "benefits-comparison-header-image-".concat(index),
      loading: "lazy",
      src: imageUrl(header === null || header === void 0 ? void 0 : header.image),
      width: 57,
      height: 26,
      alt: "Syarah",
      className: "m-auto align-middle"
    }))));
  })), tableRows.map(function (row, rowIndex) {
    var _row$table_row;
    return /*#__PURE__*/React.createElement("div", {
      id: "benefits-comparison-table-row-".concat(rowIndex),
      key: rowIndex,
      className: "grid grid-cols-[minmax(140px,1fr)_90px_110px] md:grid-cols-3 gap-0  border-gray-100"
    }, (_row$table_row = row.table_row) === null || _row$table_row === void 0 ? void 0 : _row$table_row.map(function (cell, cellIndex) {
      var _cell$image, _cell$image2;
      return /*#__PURE__*/React.createElement("div", {
        id: "benefits-comparison-table-cell-".concat(rowIndex, "-").concat(cellIndex),
        key: cellIndex,
        className: twMerge("p-3 md:p-6 flex h-12 items-center", ((_cell$image = cell.image) === null || _cell$image === void 0 ? void 0 : _cell$image.url) && " justify-center", cellIndex === 1 ? "bg-[#E7E7F8]" : "bg-white", rowIndex !== 0 && "border-b border-solid border-[#0D0DB50D] border-[1px]")
      }, cell.text && cellIndex === 0 ? /*#__PURE__*/React.createElement("p", {
        id: "benefits-comparison-cell-text-".concat(rowIndex, "-").concat(cellIndex),
        className: "text-sm md:text-[17px] font-semibold text-[#383838] leading-snug"
      }, cell.text) : (_cell$image2 = cell.image) !== null && _cell$image2 !== void 0 && _cell$image2.url ? /*#__PURE__*/React.createElement("img", {
        id: "benefits-comparison-cell-image-".concat(rowIndex, "-").concat(cellIndex),
        loading: "lazy",
        src: imageUrl(cell.image),
        alt: "",
        className: "w-5 h-5"
      }) : cell.text ? /*#__PURE__*/React.createElement("span", {
        id: "benefits-comparison-cell-value-".concat(rowIndex, "-").concat(cellIndex),
        className: "md:text-[20px] text-base text-[#383838]"
      }, cell.text) : null);
    }));
  }))))));
};
export default BenefitsComparison;